<!-- Barra de botoes para manutenção de cadastros
    <bar-manut
        single-entity="Participante"
        plural-entity="Participantes"
        :btn-delete="true"
        v-bind:crud="this.crud"
        v-on:closeform="handleMessage('closeform')"
        v-on:delete="handleMessage('delete')"
        v-on:cancel="handleMessage('cancel')"
        v-on:save="handlePost(false)">
        v-on:savenew="handlePost(true)">
    </bar-manut>

http://ruancarvalho.github.io/webdevacademy/ux/bootstrap-crud/view.html

 -->


<script>
import { SysVars } from '../main';

export default {
    props: {
        singleEntity: String,
        crud: String,
        entityPK: String,
        btnDelete: Boolean,
        btnCancel: Boolean,
        disableSave: Boolean,
        disableRetorno: Boolean,
        moreActions: Array,
    },

    data () {
        return {
            title: '',
            crudText: '',
            titleClose: '',
            titleOK: '',
            titleCancel: '',
            titleDelete: '',
            buttonRetorno: false,
            buttonCancel: false,
            buttonDelete: false,
            buttonSave: false,
            modalCancel: false,
            modalDelete: false,
            disabledTitle: '',
        }
    },

    computed: {
    },

    methods: {
        closeForm() {
            this.$emit('closeform')
        },

        handleSave() {
            this.$emit('save')
        },

        handleSaveNew() {
            this.$emit('savenew')
        },

        confirm() {
            this.$emit('confirm')
        },

        handleCancel() {
            this.closeModal()
            this.$emit('cancel')
        },

        handleDelete() {
            this.closeModal()
            this.$emit('delete')
        },

        closeModal() {
            this.modalCancel = false
            this.modalDelete = false
        },

        confirmMessage(action) {
            //exibe a mensagem de confirmacao de cancelamento ou exclusao
            if(action == 'del') {
                this.modalDelete = true
            } else {
                this.modalCancel = true
            }
        },

        clickAction(act) {
            this.$emit('action', act)
        },


    },

    watch: {
        disableSave: function(newValue, oldValue) {
            if (this.disableSave)  {
               this.disabledTitle = 'Por favor, corrija os campos em destaque.'
          } else {
               this.disabledTitle = ''
          }
          this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
          })
        },

        disableRetorno: function(newValue, oldValue) {
            if (this.disableRetorno)  {
               this.buttonRetorno = false
          } else {
               this.buttonRetorno = true
          }
        }
    },

    destroyed () {
    },

    mounted () {
    },

    created () {

        this.crudText = this.$crudText(this.crud)
        this.buttonSave = false
        this.buttonDelete = false
        this.buttonCancel = false
        if (this.disableRetorno)
            this.buttonRetorno = false
        else
            this.buttonRetorno = true

        this.titleClose = ''
/*
        if (this.crud == SysVars.crudI) {
            this.buttonSave = true
        } else if (this.crud == SysVars.crudU) {
            this.buttonSave = true
        } else if (this.crud == SysVars.crudD) {
            this.buttonSave = true
            this.titleDelete = 'Clique para confirmar a exclusão de ' + this.singleEntity
        } else if (this.crud == SysVars.crudC) {
            this.buttonCancel = true
            this.titleCancel = 'Clique para confirmar o cancelamento de ' + this.singleEntity
        }
*/
        if (this.crud == SysVars.crudInsert) {
            this.buttonSave = true
        } else if (this.crud == SysVars.crudUpdate) {
            this.buttonSave = true
        }

        if (this.crud != SysVars.crudInsert) {
            if (this.btnDelete) {
                this.buttonDelete = true
                this.titleDelete = 'Clique para confirmar a exclusão'
            }
            if (this.btnCancel) {
                this.buttonCancel = true
                this.titleCancel = 'Clique para confirmar o cancelamento'
            }
        }

        this.title = this.crudText + ' ' + this.singleEntity
        if (this.entityPK) {
          this.title = this.title + ' (' + this.entityPK + ')'
        }



    }

}
</script>

<template>
    <div id="top" class="row nb-margin-bottom align-items-center">
        <div class="col-md-6 col-12">
            <h4 class="def-title">{{ title }}</h4>
        </div>
        <div class="col-md-6 col-12 mt-md-0 mt-3">
            <div class="btn-group float-right">
                <v-button :tabindex="1" label="Retornar" title="" @click="closeForm" icon="fa-arrow-left" v-if="buttonRetorno"></v-button>
                <span class="d-inline-block" tabindex="0" data-toggle="tooltip" :title="disabledTitle">
                    <v-button label="Salvar" :nb-btdef="true" @click="handleSave" icon="fa-save" :disabled="disableSave" v-if="buttonSave"></v-button>
                </span>
                <v-button :tabindex="1" label="Cancelar" :title="titleCancel" :danger="true" @click="confirmMessage('can')" v-if="buttonCancel"></v-button>
                <v-button :tabindex="1" label="" :title="titleDelete" @click="confirmMessage('del')" icon="fa-trash" v-if="buttonDelete"></v-button>
            </div>
            <!-- botao mais acoes -->
            <div class="btn-group float-right" v-if="moreActions && moreActions.length">
                <v-button label="Mais Ações" @click="clickAction" :actions="moreActions"></v-button>
            </div>

        </div>
        <md-message v-if="modalDelete" :tabindex="1" code="delete" @confirm="handleDelete()" @close="closeModal()"></md-message>
        <md-message v-if="modalCancel" :tabindex="1" code="cancel" @confirm="handleCancel()" @close="closeModal()"></md-message>
    </div>

</template>





// WEBPACK FOOTER //
// src/components/bar-manut.vue